import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from '../../plugins/vuetify';
import { sync } from 'vuex-router-sync'
import store from '@/store/store'

sync(store, router);
// eslint-disable-next-line no-console
new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app');